import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Solutions } from "@/components/site/Solutions";
import { WhyLark } from "@/components/site/WhyLark";
import { GlobalPresence } from "@/components/site/GlobalPresence";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-white text-lark-ink" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Solutions />
        <WhyLark />
        <GlobalPresence />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
